export const adaptPacienteProbable = (pacienteProbableData) => {
    return {
        delegacion: pacienteProbableData?.idDelegacionNavigation?.descripcion,
        idPrePaciente: pacienteProbableData?.idPrePaciente,
        nombre: pacienteProbableData?.nombre,
        apellido: pacienteProbableData?.apellido,
        institucion: pacienteProbableData?.codInstitucion
            ? (pacienteProbableData?.codInstitucionNavigation?.cod_Institucion || '') + ' - ' + (pacienteProbableData?.codInstitucionNavigation?.nombre || '')
            : '-',
        programa: pacienteProbableData?.idTipoModuloNavigation?.abreviacion,
        idEstado: pacienteProbableData?.idEstado,
        fechaAlta: pacienteProbableData?.fechaAlta,
        usuario: pacienteProbableData?.idUsuarioAltaNavigation?.apellido + ', ' + pacienteProbableData?.idUsuarioAltaNavigation?.nombre,
        fechaAltaProbable: pacienteProbableData?.fechaAltaProbable,
    }
}

export const adaptPacienteProbableArray = (
    pacienteProbable
) => {
    return structuredClone(pacienteProbable?.allPrePaciente?.items)
        ?.map(pp => adaptPacienteProbable(pp));
}